import { SquadNumberDto } from ".";

export class UpdateSquadNumbersRequestDto {
    teamId: number;
    numbers: SquadNumberDto[];
}